import React from 'react';
import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { ContentLayout, DataTable, LayoutGap } from '@gov-nx/ui/web';
import {
	generateArrayFromLength,
	generateRandomNumber,
} from '@gov-nx/utils/common';

export const DriversRegistrySkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);
	return (
		<ContentLayout>
			<div className="flex gap-8 pb-3 overflow-hidden">
				<GovSkeleton
					width="100px"
					height="32px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<GovSkeleton
					width="100px"
					height="32px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<GovSkeleton
					width="78px"
					height="32px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<LayoutGap
				gap="s"
				className="p-6">
				<GovSkeleton
					width="150px"
					height="30px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
				<div className="[ md:w-[360px] ]">
					<GovSkeleton
						width="100%"
						height="21px"
						aria-label={t('loading.wcag.processing', {
							namespace: LocalizeNameSpaceTypes.Global,
						})}
					/>
				</div>
				<GovSkeleton
					width="170px"
					height="38px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</LayoutGap>
			<div className="mt-6 mb-4">
				<GovSkeleton
					width="170px"
					height="30px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<DataTable responsive>
				<tbody>
					{generateArrayFromLength(3).map((i) => (
						<tr key={i}>
							<td className="sm:w-1/2!">
								<GovSkeleton
									height="19px"
									width={generateRandomNumber(20, 30) + '%'}
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
								/>
							</td>
							<td>
								<GovSkeleton
									height="19px"
									width="100px"
									aria-label={t('loading.wcag.processing', {
										namespace: LocalizeNameSpaceTypes.Global,
									})}
									className="flex grow"
								/>
							</td>
						</tr>
					))}
				</tbody>
			</DataTable>
			<div className="mt-12 mb-4">
				<GovSkeleton
					width="170px"
					height="30px"
					aria-label={t('loading.wcag.processing', {
						namespace: LocalizeNameSpaceTypes.Global,
					})}
				/>
			</div>
			<DataTable responsive>
				<tbody>
					<tr>
						<td className="sm:w-1/2!">
							<GovSkeleton
								height="19px"
								width={generateRandomNumber(20, 30) + '%'}
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
							/>
						</td>
						<td>
							<GovSkeleton
								height="19px"
								width="100px"
								aria-label={t('loading.wcag.processing', {
									namespace: LocalizeNameSpaceTypes.Global,
								})}
								className="flex grow "
							/>
						</td>
					</tr>
				</tbody>
			</DataTable>
		</ContentLayout>
	);
};
